import { useRef, useState } from "react";
import RecessImage from "../../../Assets/Images/pex1.png";
import RecessImageTwo from "../../../Assets/Images/pex2.png";
import RecessImageThree from "../../../Assets/Images/pex3.png";
import {
  MEDIA_LINKS,
  COMMON_THUMBNAIL_URL,
} from "../../../Constants/mediaLinks";
import { BsFillPlayCircleFill, BsFillPauseCircleFill } from "react-icons/bs";
import RecessPImage from "../../../Assets/Images/gr1.png";
import schoolProgramRec from "../../../Assets/Images/school-programs-rec-day.png";
import PricingBlock from "../ChoosePlans/PricingBlock";
import recDay from "../../../Assets/Images/rec-day.png";
import recDayMobile from "../../../Assets/Images/rec-day-mobile.png";
import "./sportsrecday.css";

const SportsRecDay = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleVideoEnd = () => {
    setIsPlaying(false);
  };

  const plans = [
    {
      color: "#2B6DE1",
      title: "Sports & Rec Packages",
      price: "$ 1,175",
      features: [
        "Choose One: Basketball, Soccer or Football",
        "Skills & Drills in the morning",
        "Break for lunch",
        "Games, contests, and tournaments",
      ],
      image: schoolProgramRec,
      bottomImage: RecessPImage,
    },
  ];
  return (
    <div className="sports-rec-day">
      <div className="recess-heading">
        <div className="new-image-border">
          <img className="sports-img-desktop" src={recDay} alt="rec-day" />
          <img
            className="sports-img-mobile"
            src={recDayMobile}
            alt="rec-day-mobile"
          />
          {/* <h2>Sports & Rec Day</h2>
          <div className="recess-images">
              <img src={RecessImage} alt="recess" />
              <img src={RecessImageTwo} alt="recess" />
              <img src={RecessImageThree} alt="recess" />
          </div> */}
        </div>
      </div>
      <div className="sports-rec-day-content">
        <div className="choose-plans-list srd-plans-list">
          {plans.map((plan, index) => (
            <PricingBlock
              key={index}
              title={plan.title}
              price={plan.price}
              features={plan.features}
              image={plan.image}
              color={plan.color}
              bottomImage={plan.bottomImage}
            />
          ))}
        </div>

        <div className="video-container srd-video-container">
          <div
            style={{
              width: "100%",
              height: "600px",
              overflow: "hidden",
              borderRadius: "20px",
            }}
          >
            <video
              controls
              autoPlay
              muted
              poster={MEDIA_LINKS.SCHOOL_PROGRAMS.VIDEO_02}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain", // fills container, crops if needed
              }}
            >
              <source
                src={MEDIA_LINKS.SCHOOL_PROGRAMS.VIDEO_02}
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SportsRecDay;
